module.exports = __webpack_public_path__ + "img/system_zasilania_wody_02.950c2cd8.jpg";